import {dataSourceDefinition as cmsSourceDefinition} from '@packages/systems/cms/gateway/core';
import {dataSourceDefinition as ecommerceSourceDefinition} from '@packages/systems/commerce/gateway/core';
import {dataSourceDefinition as searchSourceDefinition} from '@packages/systems/search';
import {dataSourceDefinition as siteUserDefinition} from '@packages/systems/users/gateway';
import type {DataSourceDefinition} from '@packages/systems/dynamo/source-types';

export const dataSources: DataSourceDefinition[] = [
  cmsSourceDefinition,
  ecommerceSourceDefinition,
  searchSourceDefinition,
  siteUserDefinition,
];
